module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-EVA_1.0c38ac48.jpg";